import { Route, Routes } from "react-router-dom";
import { ProtectedRoute } from "./ProtectedRoute";
import { ROLES } from "./constants/roles";
import {
  CashCollectionPage,
  HomePage,
  PageNotFoundPage,
  BatteryMovementPage,
  ManualSwapPage,
} from "./pages";

const AppRoutes = () => {
  return (
    <Routes>
      <Route path="/" element={<HomePage />} />
      <Route
        path="/cash-collection"
        element={
          <ProtectedRoute role={ROLES.CASH_COLLECTION}>
            <CashCollectionPage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/manual-swap"
        element={
          <ProtectedRoute role={ROLES.MANUAL_SWAP}>
            <ManualSwapPage />
          </ProtectedRoute>
        }
      />

      <Route
        path="/battery-movement"
        element={
          <ProtectedRoute role={ROLES.BATTERY_MOVEMENT}>
            <BatteryMovementPage />
          </ProtectedRoute>
        }
      />

      <Route path="*" element={<PageNotFoundPage />} />
    </Routes>
  );
};

export default AppRoutes;
